import request from '@/utils/request'

// 查询分类列表
export function industryCategoryList (query) {
  return request({
    url: '/setting/industryCategory/list',
    method: 'get',
    params: query
  })
}
// 获取行业分类详细信息
export function industryCategoryDetail (id) {
  return request({
    url: '/setting/industryCategory/' + id,
    method: 'get'
  })
}
// 删除行业分类
export function deleteIndustryCategory (id) {
  return request({
    url: '/setting/industryCategory/' + id,
    method: 'delete'
  })
}
// 新增行业分类
export function addIndustryCategory (data) {
  return request({
    url: '/setting/industryCategory',
    method: 'post',
    data: data
  })
}
// 修改行业分类
export function editIndustryCategory (data) {
  return request({
    url: '/setting/industryCategory',
    method: 'put',
    data: data
  })
}
